<template lang="pug">

  div
    header(id="ht-masthead" class="ht-site-header ht-header-six hover-style9")
      div(class="ht-header headroom headroom--top headroom--not-bottom")
        div(class="ht-container")
          div(id="ht-site-branding")
            // a(href="https://ezwash.tw/wordpress/" class="custom-logo-link" rel="home")
            router-link(:to={name:'info'} class="custom-logo-link" rel="home")
              img(width="567" height="184" src="https://ezwash.tw/wordpress/wp-content/uploads/2020/03/cropped-資產-34@3x.png" class="custom-logo" alt="EZWASH" srcset="https://ezwash.tw/wordpress/wp-content/uploads/2020/03/cropped-資產-34@3x.png 567w, https://ezwash.tw/wordpress/wp-content/uploads/2020/03/cropped-資產-34@3x-300x97.png 300w" sizes="(max-width: 567px) 100vw, 567px")
            .header-title 線上預約洗衣平台
          nav(id="ht-site-navigation" class="ht-main-navigation")
            a(class="ht-header-bttn ht-mobile-hide" href="https://ezwash.tw") &nbsp;&nbsp;回首頁&nbsp;&nbsp;
    router-view
</template>

<script>

export default {
  name: 'app',
  mounted () {
    const id = location.search.slice(1)
    if (id) {
      this.$store.commit('setEmployeeID', id)
    }
  }
}
</script>
<!--<style lang="scss" src="@/assets/new_style.scss"></style>-->

